/**
 * 主要功能
 * 1、无权限跳转到无权限页面提示
 * 2、 user更新时刷新refreshInit
 */

import { setCookie } from 'library-@/utils/commonInitCookie.umd';
export default class TokenHandlerService {
    /**
    * 当前token
    */
    token;

    /**
    * token解析后数据
    */
    tokenData;

    constructor(token) {
        if (!token) return;
        this.token = token;
        this.parseToken();
    }

    get lastLoginSessionId() {
        return localStorage.getItem('last_login_session_id');
    }

    get currentLoginSessionId() {
        return this.tokenData.session;
    }

    get authzCode () {
        return this.tokenData.authz_code;
    }

    get authzParam() {
        return this.tokenData.authz_param;
    }

    parseToken() {
        const tokenStr = this.token.split('.')[1];
        // IE10都支持 https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/atob
        this.tokenData = JSON.parse(window.atob(tokenStr));
    }

    storeSessionId() {
        localStorage.setItem('last_login_session_id', this.currentLoginSessionId);
    }

    refreshInit() {
        if (this.currentLoginSessionId && this.currentLoginSessionId !== this.lastLoginSessionId) {
            setCookie('refreshInit', true);
        }
    }

    checkTokenPermission() {
        const isRequestDemo = window.location.pathname === '/request_demo';
        const isPatentView = (window.location.pathname).includes('/patent-view');
        if (this.authzCode && this.authzParam && !isRequestDemo && !isPatentView) {
            window.location.href = `/request_demo?project=analytics&errcode=${this.authzCode}&param=${this.authzParam}`;
            return true;
        }
    }
}
